<template>
    <div v-if="loading == false">
        <div  v-if="Object.keys(pipeline_activity).length">
            <div class="media d-flex align-items-start activity  mt-1" v-for="(activity,index) in pipeline_activity">
                <div class="avatar me-2 flex-shrink-0 mt-2">
                    <span class="avatar-initial pipeline bg-label-info rounded-circle">CF</span>
                </div>
                <div class="media-body">
                    <p class="mb-0" v-if="activity.note">
                        <Popper >
                            <span class="font-weight-bold activity_text"> 
                                <span style="text-transform: capitalize;">{{activity.Added_by.full_name == ""?activity.Added_by.name:activity.Added_by.full_name}}</span> <span style="font-size:13px;">{{activity.activity.toLowerCase()}}</span> 
                                <span style="color:#4b9a5e;font-size:13px;"> Read More </span>
                            </span>
                            <template #content>
                                <div>
                                    <h3 style="color:rgb(75, 154, 94) !important;font-size: 15px;text-transform: capitalize;">
                                        {{activity.Added_by.full_name == "" ? activity.Added_by.name:activity.Added_by.full_name}} Note
                                    </h3>
                                    <p style="color:black !important;">
                                        {{activity.note.note}}
                                    </p>
                                </div>
                            </template>
                        </Popper>
                    </p>
                    <p class="mb-0" v-else>
                        <span class="font-weight-bold activity_text" style="text-transform: capitalize;"> {{ activity.Added_by.full_name == "" ? activity.Added_by.name:activity.Added_by.full_name }}</span>  <span style="font-size:13px;">{{ activity.activity.toLowerCase()}}</span>.
                    </p>
                    <small class="text-muted">{{ formartDate(activity.created_at) }}</small>
                </div>
            </div>
            <div class="">
                <center>
                    <button type="button" v-on:click="getPipelineActivity" class="btn btn-primary mt-1 waves-effect waves-light" v-if="hide_load_more">{{ loading_message }}</button>
                </center>
            </div>
        </div>
        <div class="text-center" style="text-align: center; font-size: 1.1rem; font-weight: 300;" v-else>
            No Active Pipeline
        </div>
    </div>
    <div v-else>
        <p style="text-align: center; font-size: 1.1rem; font-weight: 600;margin-top:20px;">Loading Pipeline Activities</p>
    </div>
    
    
    
</template>
<script>
import {ref,reactive} from 'vue'
import {usePipelineStore} from '../../../../../../stores/PipelineStore.js';
import Popper from "vue3-popper";
import moment from 'moment'
export default{
    name:'PipelineActivity',
    display: "Pipeline Activity",
    components:{
        Popper
    },
    setup(){
        const pipeline_activity = ref([]),
        pipeline = usePipelineStore(),
        hide_load_more = ref(true),
        next_page=1,
        loading_message=ref('Load More'),
        loading = ref(false);
        return{
            pipeline_activity,
            pipeline,
            next_page,
            hide_load_more,
            loading_message,
            loading
        }
    },
    watch:{
        async 'pipeline_activity'(value){
        }
    },
    mounted(){
        this.getPipelineActivity();
    },
    methods:{
        getPipelineActivity(){
            const $this=this;
            $this.loading_message = 'Fetching Client Activities...'
            $this.loading = true;
            if(this.pipeline.client_id == null){
                toastr.error('An error occured while getting pipeline activity', 'Error!');
                return false;
            }
            const route = this.$router.resolve(
                {
                    name:"pipeline.show.activity",
                    params:{
                        client: this.pipeline.client_id
                    }
                }
            );
            axios.get(route.href+"?page="+this.next_page).then(({data})=>{
                if(data.error != true){
                    $this.loading_message = 'Load More'
                    $this.loading = false;
                    data.data.data.forEach(values => {
                        $this.pipeline_activity.push(values);
                    });
                    if($this.next_page <= data.data.last_page){
                        $this.next_page++;
                        $this.hide_load_more = true;
                    }
                    if($this.next_page > data.data.last_page){
                        $this.hide_load_more = false
                    }
                    return true;
                }else{
                    $this.loading_message = 'Load More'
                    $this.loading = false;
                    toastr.error('Pipeline activity not fetched', 'Error!');
                    return false;
                }
            }).catch(function(error) {
                $this.loading_message = 'Load More'
                $this.loading = false;
                toastr.error(error.response.data.response_msg, 'Error!');
                return false;
            });
        },
        formartDate(date){
            return moment(date).format('llll');
        }
    }
}
</script>
<style>
    .activity .avatar{
        cursor: pointer;
        height: 2.375rem;
        position: relative;
        width: 2.375rem;
        margin-top: 0.5rem!important;
        margin-right: 0.5rem!important;
    }
    .activity .avatar-initial.pipeline{
        align-items: center;
        background-color: #00cfe8 !important;
        bottom: 0;
        color: #fff;
        display: -ms-flexbox;
        display: flex;
        font-weight: 600;
        justify-content: center;
        left: 0;
        position: absolute;
        right: 0;
        text-transform: uppercase;
        top: 0;
    }
    .activity_text{
        font-weight: 500;
        font-size: 15px;
    }
    :root {
        --popper-theme-background-color: #ffffff;
        --popper-theme-background-color-hover: #ffffff;
        --popper-theme-text-color: #ffffff;
        --popper-theme-border-width: 0px;
        --popper-theme-border-style: solid;
        --popper-theme-border-radius: 6px;
        --popper-theme-padding: 12px;
        --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
    }
    .popper{
        width:80%;
    }
</style>
